import { useEffect } from 'react';
import { useMapStore } from '../MapStore/UseMapStore';

export function useRotatedOverlay() {
  const selected = useMapStore((s) => s.selected);
  const mapInstance = useMapStore((s) => s.mapInstance);
  const boundsLayer = useMapStore((s) => s.boundsLayer);
  const imageLayer = useMapStore((s) => s.imageLayer);
  const setOverlayFC = useMapStore((s) => s.setOverlayFC);

  const isOverlaySelected = selected === 'overlay';

  useEffect(() => {
    if (!isOverlaySelected || !mapInstance || !boundsLayer || !imageLayer) return;

    const layers = Object.values(boundsLayer._layers);
    let rafId: number | null = null;

    const updateImage = (layer: any) => {
      if (rafId) cancelAnimationFrame(rafId);

      rafId = requestAnimationFrame(() => {
        setOverlayFC(boundsLayer.toGeoJSON());

        imageLayer.reposition(
          layer._latlngs[0][3], // bottom-left
          layer._latlngs[0][2], // bottom-right
          layer._latlngs[0][0], // top-left
        );
      });
    };

    layers.forEach((layer: any) => {
      layer.on('transformed', () => updateImage(layer));
    });

    return () => {
      layers.forEach((layer: any) => {
        layer.off('transformstart transform');
        layer.off('transformed');
      });
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, [isOverlaySelected, boundsLayer, imageLayer, mapInstance, setOverlayFC]);
}
